import { createContext, useContext, useState } from "react";

const STRINGS = {
    en: {
        nav_home: "Home", nav_about: "About", nav_event: "Event", nav_tickets: "Tickets",
        nav_vote: "Your City", nav_gallery: "Gallery", nav_shop: "Shop", nav_journal: "Journal", nav_contact: "Contact",
        nav_cta: "Get Tickets",
        hero_overline: "December 12, 2026 — Léogâne, Haiti",
        hero_title_1: "More than music.", hero_title_2: "More than an event.", hero_title_3: "A feeling.",
        hero_sub: "Where Afro House, Amapiano, Haitian culture, and unforgettable energy come together.",
        hero_cta1: "Get Tickets", hero_cta2: "Discover Lakou",
        cd_days: "Days", cd_hours: "Hours", cd_minutes: "Minutes", cd_seconds: "Seconds",
        lineup_eyebrow: "The sound of the night", lineup_title: "Official Lineup", special_guest: "Special Guest",
        vip_eyebrow: "VIP Experience", vip_title: "Reserve Your VIP Table",
        vip_sub: "Skip the line and own the night — call our team to reserve VIP tables and premium spots behind the deck.",
        vip_note: "Call to reserve — limited VIP availability",
        rc_receipt: "Receipt", rc_tickets: "Ticket(s)", rc_fee: "Processing fee", rc_total: "Total paid",
        rc_method: "Payment method", rc_txid: "Transaction ID", rc_conf: "Confirmation №",
        rc_vip_title: "VIP RESERVATIONS & INFORMATION",
        rc_vip_sub: "For VIP reservations or VIP table inquiries, contact LAKOU:",
        rc_pdf: "Download PDF receipt",
        urgency_line: "Secure your access — Léogâne, get ready.",
        intro_eyebrow: "The LAKOU feeling",
        intro_title: "Where music becomes an experience.",
        intro_body: "LAKOU brings together Afro House, Amapiano, Afrobeats and international electronic sounds in one unforgettable Haitian atmosphere — a night where rhythm, culture and connection become something you feel long after it ends.",
        social_eyebrow: "Stay connected", social_title: "Follow the movement",
        social_share: "Share LAKOU", social_share_done: "Link copied",
        newsletter_title: "Join the Movement",
        newsletter_sub: "Event announcements, early ticket access, merch drops and new cities — first.",
        newsletter_btn: "Subscribe",
        newsletter_done: "Welcome to the movement. You're on the list.",
        vote_title: "Where should Lakou go next?",
        vote_sub: "LAKOU was born in Haiti. Now help us decide where the feeling travels next.",
        vote_cta: "Vote for your city", vote_btn: "Vote", vote_voted: "Voted",
        footer_line: "Born in Haiti. Felt everywhere.",
        home_movement: "The Movement",
        home_shop_eyebrow: "Wear the feeling",
        home_gallery_eyebrow: "The feeling, captured",
        spread: "Spread the feeling",
        tell_people: "{days} days out. Tell your people.",
        days_until: "days until the feeling",
        share_copy: "Copy text", share_copied: "Copied",
        tickets_title: "Secure your place in the feeling",
        your_details: "Your details",
        form_name: "Full name", form_email: "Email (tickets are sent here)", form_phone: "Phone (optional)",
        qty: "Quantity", total: "Total",
        continue_payment: "Continue to secure payment",
        select_ticket_first: "Select a ticket type above",
        sale_soon: "Sale opening soon", sold_out: "Sold out", remaining: "remaining", free_label: "FREE",
        processing_note: "Card processing included — nothing more at checkout",
        get_free: "Get my free tickets", free_note: "No payment needed · QR ticket issued instantly",
        tap_select: "Tap to select", selected: "Selected",
        notify_title: "Tickets drop soon", notify_sub: "Leave your email and you'll be the first to know the moment tickets go on sale.",
        notify_btn: "Notify me", notify_thanks: "You're on the list — we'll email you the moment tickets go live.",
        pay_method: "Payment method",
        pay_card: "Card", pay_card_sub: "Secure card checkout",
        pay_mobile_sub: "Mobile money in HTG",
        mm_title: "Complete your payment",
        mm_send: "Send {htg} HTG to {number}",
        mm_reference: "Reference code — write it in the transfer note",
        mm_note: "Your tickets are emailed only after our team sees the money in our wallet — usually within a few hours.",
        mm_step1: "Step 1 — Send the money FIRST",
        mm_step2: "Step 2 — After sending, confirm your payment below",
        pending_title: "Payment not confirmed yet",
        pending_sub: "MonCash did not confirm this payment. No charge was completed and no ticket was issued. If you already paid, contact us with your reference below and we'll sort it out right away.",
        mm_sender: "Your phone number you paid from",
        mm_txid: "Transaction ID (from the confirmation SMS — optional)",
        mm_paid: "I have paid",
        mm_done_title: "Payment sent for review",
        mm_done_text: "Mèsi! Our team is verifying your {method} transfer. Your QR tickets will arrive by email at {email} as soon as it's confirmed.",
        mm_done_text_shop: "Thank you! Our team is verifying your {method} payment. Your order confirmation will arrive by email at {email} as soon as it's confirmed.",
        mm_new_order: "Start a new order",
        secure_card_note: "Secure Stripe checkout · QR ticket issued instantly after payment",
        shop_checkout: "Checkout", shop_pay: "Pay securely", shop_clear: "Clear", shop_add: "Add", shop_soon: "Soon",
        cart_title: "Your Cart", cart_empty: "Your cart is empty. The merch table awaits.", cart_subtotal: "Subtotal",
        event_date: "Date", event_location: "Location", tickets_live: "Tickets drop soon",
        faq_eyebrow: "Good to know", faq_title: "Questions, answered",
        contact_title: "Contact & Partnerships", contact_send: "Send message",
        journal_title: "The LAKOU Journal", gallery_title: "The Memories. The Music. The Experience.",
        read: "Read", journal_empty: "Stories are being written. Check back soon.",
        about_eyebrow: "Our story",
        about_title: "More than an event. A movement.",
        about_p1: "In Haiti, the lakou is the courtyard — the shared space where families gather, drums sound, and life is lived together. We took that word and built a movement on it.",
        about_p2: "LAKOU blends Afro House, Amapiano, Afrobeats, and Haitian music into premium open-air experiences — cinematic sound, warm light, beautiful people, and energy you can't manufacture.",
        about_p3: "On December 12, 2026, the feeling comes to life in Léogâne. After that, the island. After that, the world.",
        v1t: "The drum first", v1d: "Afro House, Amapiano, Rabòday — rhythm is our mother tongue.",
        v2t: "Community over crowd", v2d: "Lakou means courtyard — the heart of Haitian communal life. Everyone belongs.",
        v3t: "Haiti to the world", v3d: "Built at home, designed for the world stage. One island, many cities.",
        v4t: "A feeling, not an event", v4d: "We don't sell nights out. We create moments people carry with them.",
        grow_title: "Grow with the movement",
        grow_sub: "Lineup announcements, ticket drops, and new cities — hear it first.",
        login_sub: "Sign in to your account", login_google: "Continue with Google", login_or: "or team login",
        login_btn: "Sign in", login_note: "Staff & admin accounts are provided by the LAKOU team.",
        pay_confirming: "Confirming your payment…",
        pay_in_ticket: "You're in. See you in Léogâne.", pay_in_shop: "Order confirmed.",
        pay_ticket_sub: "Your QR tickets are below and linked to your email. Show them at the entrance.",
        pay_shop_sub: "Thank you for wearing the feeling. Your merch order is confirmed.",
        pay_back: "Back home", pay_fail: "We couldn't confirm this payment",
        pay_fail_sub: "If you completed payment, your tickets will appear shortly — or contact us and we'll sort it out.",
        cancel_title: "Payment cancelled",
        cancel_sub: "No charge was made. Your spot is still waiting whenever you're ready.",
        cancel_tickets: "Back to tickets",
        ci_title: "Ticket Check-in", ci_scan: "Scan with camera", ci_stop: "Stop camera",
        ci_or: "or type the code", ci_validate: "Validate & check in",
        contact_general: "General", contact_partner: "Partner With Us",
        form_message: "How can we help?",
        mm_attach: "Attach your transfer screenshot (speeds up confirmation)",
        mm_attached: "Screenshot attached",
    },
    ht: {
        nav_home: "Akèy", nav_about: "Konsènan", nav_event: "Evènman", nav_tickets: "Tikè",
        nav_vote: "Vil Ou", nav_gallery: "Galeri", nav_shop: "Boutik", nav_journal: "Jounal", nav_contact: "Kontak",
        nav_cta: "Pran Tikè",
        hero_overline: "12 Desanm 2026 — Leyogàn, Ayiti",
        hero_title_1: "Plis pase mizik.", hero_title_2: "Plis pase yon evènman.", hero_title_3: "Yon santiman.",
        hero_sub: "Kote Afro House, Amapiano, kilti ayisyen, ak enèji ekselans rankontre.",
        hero_cta1: "Pran Tikè", hero_cta2: "Dekouvri Lakou",
        cd_days: "Jou", cd_hours: "È", cd_minutes: "Minit", cd_seconds: "Segond",
        lineup_eyebrow: "Son aswè a", lineup_title: "Atis ofisyèl yo", special_guest: "Envite Espesyal",
        vip_eyebrow: "Eksperyans VIP", vip_title: "Rezève tab VIP ou",
        vip_sub: "Pase devan liy nan epi posede nuit la — rele ekip nou an pou w rezève tab VIP ak plas premium dèyè DJ a.",
        vip_note: "Rele pou rezève — plas VIP yo limite",
        rc_receipt: "Resi peman an", rc_tickets: "Tikè", rc_fee: "Frè peman kat", rc_total: "Total ou peye",
        rc_method: "Fason ou peye", rc_txid: "Nimewo tranzaksyon", rc_conf: "Nimewo konfirmasyon",
        rc_vip_title: "VIP RESERVATIONS & INFORMATION",
        rc_vip_sub: "Pou rezervasyon VIP oswa tab VIP, kontakte LAKOU:",
        rc_pdf: "Telechaje resi PDF a",
        urgency_line: "Pwoteje plas ou — Leyogàn, pare w.",
        intro_eyebrow: "Sansasyon LAKOU a",
        intro_title: "Kote mizik vin yon eksperyans.",
        intro_body: "LAKOU mete Afro House, Amapiano, Afrobeats ak son elektwonik entènasyonal ansanm nan yon atmosfè ayisyen ou pap janm bliye — yon nwit kote ritm, kilti ak koneksyon rete nan kò w lontan apre l fini.",
        social_eyebrow: "Rete konekte", social_title: "Swiv mouvman an",
        social_share: "Pataje LAKOU", social_share_done: "Lyen an kopye",
        newsletter_title: "Antre nan Mouvman an",
        newsletter_sub: "Anons evènman, tikè an avans, merch ak nouvèl vil — an premye.",
        newsletter_btn: "Abòne",
        newsletter_done: "Byenvini nan mouvman an. Ou nan lis la.",
        vote_title: "Ki vil LAKOU ta dwe ale apre?",
        vote_sub: "LAKOU fèt ann Ayiti. Koulye a ede nou chwazi kote santiman an prale.",
        vote_cta: "Vote pou vil ou", vote_btn: "Vote", vote_voted: "Ou vote",
        footer_line: "Li fèt ann Ayiti. Tout moun santi l.",
        home_movement: "Mouvman an",
        home_shop_eyebrow: "Mete santiman an sou ou",
        home_gallery_eyebrow: "Santiman an nan foto",
        spread: "Pataje santiman an",
        tell_people: "Rete {days} jou. Di moun pa ou yo.",
        days_until: "jou avan santiman an",
        share_copy: "Kopye tèks la", share_copied: "Ou kopye l",
        tickets_title: "Asire plas ou nan santiman an",
        your_details: "Enfòmasyon ou",
        form_name: "Non konplè", form_email: "Imèl (tikè yo voye la)", form_phone: "Telefòn (si ou vle)",
        qty: "Kantite", total: "Total",
        continue_payment: "Kontinye nan peman sekirize",
        select_ticket_first: "Chwazi yon tip tikè anlè a",
        sale_soon: "Vant ap ouvri talè", sold_out: "Vann net", remaining: "ki rete", free_label: "GRATIS",
        processing_note: "Frè kat la ladan l — pa gen anyen ankò pou peye",
        get_free: "Pran tikè gratis mwen", free_note: "Peye anyen · Tikè QR ou parèt touswit",
        tap_select: "Tape pou chwazi", selected: "Ou chwazi l",
        notify_title: "Biyè yo ap soti talè", notify_sub: "Kite imel ou la epi w ap premye moun ki konnen lè biyè yo mete ann vant.",
        notify_btn: "Avèti m", notify_thanks: "Ou sou lis la — n ap voye imel ba ou lè biyè yo soti.",
        pay_method: "Metòd peman",
        pay_card: "Kat", pay_card_sub: "Peman kat sekirize",
        pay_mobile_sub: "Lajan mobil an goud",
        mm_title: "Fini peman ou",
        mm_send: "Voye {htg} goud sou {number}",
        mm_reference: "Kòd referans — ekri l nan nòt transfè a",
        mm_note: "Nap voye tikè yo pa imèl sèlman apre ekip nou WÈ lajan an nan bous nou — anjeneral nan kèk èdtan.",
        mm_step1: "Etap 1 — Voye lajan an ANVAN",
        mm_step2: "Etap 2 — Apre ou voye l, konfime peman ou anba a",
        pending_title: "Peman an poko konfime",
        pending_sub: "MonCash pa konfime peman sa a. Okenn kòb pa t soti e okenn tikè pa t pare. Si ou deja peye, kontakte nou ak referans ou anba a e n ap regle l touswit.",
        mm_sender: "Nimewo telefòn ou peye ak",
        mm_txid: "Nimewo tranzaksyon (nan SMS konfirmasyon an — si ou vle)",
        mm_paid: "Mwen peye",
        mm_done_title: "Peman an voye pou verifye",
        mm_done_text: "Mèsi! Ekip nou ap verifye transfè {method} ou a. Tikè QR ou yo ap rive nan imèl {email} touswit li konfime.",
        mm_done_text_shop: "Mèsi! Ekip nou ap verifye peman {method} ou a. Konfirmasyon kòmand ou ap rive nan imèl {email} touswit li konfime.",
        mm_new_order: "Kòmanse yon lòt kòmand",
        secure_card_note: "Peman Stripe sekirize · Tikè QR ou pare touswit peman a fèt",
        shop_checkout: "Peye", shop_pay: "Peye an sekirite", shop_clear: "Vide", shop_add: "Ajoute", shop_soon: "Talè",
        cart_title: "Panye Ou", cart_empty: "Panye ou vid. Tab merch la ap tann ou.", cart_subtotal: "Soutotal",
        event_date: "Dat", event_location: "Kote", tickets_live: "Biyè yo ap soti talè",
        faq_eyebrow: "Bon pou konnen", faq_title: "Kesyon, repons",
        contact_title: "Kontak & Patenarya", contact_send: "Voye mesaj",
        journal_title: "Jounal LAKOU", gallery_title: "Souvni yo. Mizik la. Eksperyans lan.",
        read: "Li", journal_empty: "Istwa yo ap ekri. Tounen talè.",
        about_eyebrow: "Istwa nou",
        about_title: "Plis pase yon evènman. Yon mouvman.",
        about_p1: "Ann Ayiti, lakou a se lakou kay la — espas kote fanmi yo reyini, tanbou yo bat, e lavi a viv ansanm. Nou pran mo sa a epi nou bati yon mouvman sou li.",
        about_p2: "LAKOU melanje Afro House, Amapiano, Afrobeats, ak mizik ayisyen nan eksperyans primyè an plen lè — son sinematik, limyè cho, bèl moun, ak yon enèji ou pa ka fabrike.",
        about_p3: "12 desanm 2026, santiman an vin vivan nan Leyogàn. Apre sa, zile a. Apre sa, lemonn.",
        v1t: "Tanbou a an premye", v1d: "Afro House, Amapiano, Rabòday — ritm se lang matènèl nou.",
        v2t: "Kominote anvan foul", v2d: "Lakou vle di lakou kay — kè lavi kominotè ayisyen. Tout moun gen plas yo.",
        v3t: "Peyi Ayiti rive nan lemonn", v3d: "Li bati lakay, li fèt pou sèn mondyal. Yon sèl zile, anpil vil.",
        v4t: "Yon santiman, pa yon evènman", v4d: "Nou pa vann sware. Nou kreye moman moun pote nan kè yo.",
        grow_title: "Grandi ak mouvman an",
        grow_sub: "Anons atis, tikè, ak nouvèl vil — tande l an premye.",
        login_sub: "Konekte sou kont ou", login_google: "Kontinye ak Google", login_or: "oswa ekip la",
        login_btn: "Konekte", login_note: "Ekip LAKOU la bay kont staff ak admin yo.",
        pay_confirming: "N ap konfime peman ou…",
        pay_in_ticket: "Ou anndan. Na wè nan Leyogàn.", pay_in_shop: "Kòmand ou konfime.",
        pay_ticket_sub: "Tikè QR ou yo anba e yo mare nan imèl ou. Montre yo nan antre a.",
        pay_shop_sub: "Mèsi paske ou mete santiman an. Kòmand merch ou a konfime.",
        pay_back: "Tounen akèy", pay_fail: "Nou pa t ka konfime peman sa a",
        pay_fail_sub: "Si ou fin peye, tikè ou yo ap parèt talè — oswa kontakte nou e nou ap regle l.",
        cancel_title: "Peman an anile",
        cancel_sub: "Okenn kòb pa t soti. Plas ou ap tann ou lè ou pare.",
        cancel_tickets: "Tounen nan tikè",
        ci_title: "Tcheke Tikè", ci_scan: "Skane ak kamera", ci_stop: "Sispann kamera",
        ci_or: "oswa tape kòd la", ci_validate: "Valide e antre",
        contact_general: "Jeneral", contact_partner: "Vin Patnè",
        form_message: "Kijan nou ka ede ou?",
        mm_attach: "Tache ekran transfè a (li konfime pi vit)",
        mm_attached: "Ekran an tache",
    },
    fr: {
        nav_home: "Accueil", nav_about: "À propos", nav_event: "Événement", nav_tickets: "Billets",
        nav_vote: "Votre ville", nav_gallery: "Galerie", nav_shop: "Boutique", nav_journal: "Journal", nav_contact: "Contact",
        nav_cta: "Billets",
        hero_overline: "12 décembre 2026 — Léogâne, Haïti",
        hero_title_1: "Plus que de la musique.", hero_title_2: "Plus qu'un événement.", hero_title_3: "Une sensation.",
        hero_sub: "Là où l'Afro House, l'Amapiano, la culture haïtienne et une énergie inoubliable se rencontrent.",
        hero_cta1: "Obtenir des billets", hero_cta2: "Découvrir Lakou",
        cd_days: "Jours", cd_hours: "Heures", cd_minutes: "Minutes", cd_seconds: "Secondes",
        lineup_eyebrow: "Le son de la nuit", lineup_title: "Programmation officielle", special_guest: "Invité spécial",
        vip_eyebrow: "Expérience VIP", vip_title: "Réservez votre table VIP",
        vip_sub: "Évitez la file et vivez la nuit en grand — appelez notre équipe pour réserver tables VIP et places premium derrière le DJ.",
        vip_note: "Appelez pour réserver — places VIP limitées",
        rc_receipt: "Reçu", rc_tickets: "Billet(s)", rc_fee: "Frais de traitement", rc_total: "Total payé",
        rc_method: "Mode de paiement", rc_txid: "ID de transaction", rc_conf: "Nº de confirmation",
        rc_vip_title: "VIP RESERVATIONS & INFORMATION",
        rc_vip_sub: "Pour les réservations VIP ou tables VIP, contactez LAKOU :",
        rc_pdf: "Télécharger le reçu PDF",
        urgency_line: "Sécurisez votre accès — Léogâne, préparez-vous.",
        intro_eyebrow: "Le feeling LAKOU",
        intro_title: "Là où la musique devient une expérience.",
        intro_body: "LAKOU réunit Afro House, Amapiano, Afrobeats et sonorités électroniques internationales dans une atmosphère haïtienne inoubliable — une nuit où le rythme, la culture et la connexion se sentent longtemps après la fin.",
        social_eyebrow: "Restez connectés", social_title: "Suivez le mouvement",
        social_share: "Partager LAKOU", social_share_done: "Lien copié",
        newsletter_title: "Rejoignez le mouvement",
        newsletter_sub: "Annonces d'événements, accès anticipé aux billets, merch et nouvelles villes — en premier.",
        newsletter_btn: "S'abonner",
        newsletter_done: "Bienvenue dans le mouvement. Vous êtes sur la liste.",
        vote_title: "Où LAKOU doit-il aller ensuite ?",
        vote_sub: "LAKOU est né en Haïti. Aidez-nous à décider où le feeling voyagera ensuite.",
        vote_cta: "Votez pour votre ville", vote_btn: "Voter", vote_voted: "Voté",
        footer_line: "Né en Haïti. Ressenti partout.",
        home_movement: "Le mouvement",
        home_shop_eyebrow: "Portez le feeling",
        home_gallery_eyebrow: "Le feeling, en images",
        spread: "Partagez le feeling",
        tell_people: "Plus que {days} jours. Prévenez vos proches.",
        days_until: "jours avant l'expérience",
        share_copy: "Copier le texte", share_copied: "Copié",
        tickets_title: "Réservez votre place dans l'expérience",
        your_details: "Vos informations",
        form_name: "Nom complet", form_email: "Email (billets envoyés ici)", form_phone: "Téléphone (facultatif)",
        qty: "Quantité", total: "Total",
        continue_payment: "Continuer vers le paiement sécurisé",
        select_ticket_first: "Choisissez un type de billet ci-dessus",
        sale_soon: "Vente bientôt ouverte", sold_out: "Épuisé", remaining: "restants", free_label: "GRATUIT",
        processing_note: "Frais de carte inclus — rien de plus au paiement",
        get_free: "Obtenir mes billets gratuits", free_note: "Aucun paiement · Billet QR émis instantanément",
        tap_select: "Touchez pour choisir", selected: "Sélectionné",
        notify_title: "Billets bientôt disponibles", notify_sub: "Laissez votre e-mail et soyez le premier informé dès l'ouverture des ventes.",
        notify_btn: "Me prévenir", notify_thanks: "Vous êtes sur la liste — nous vous écrirons dès que les billets seront en vente.",
        pay_method: "Mode de paiement",
        pay_card: "Carte", pay_card_sub: "Paiement par carte sécurisé",
        pay_mobile_sub: "Mobile money en HTG",
        mm_title: "Finalisez votre paiement",
        mm_send: "Envoyez {htg} HTG au {number}",
        mm_reference: "Code de référence — notez-le dans le motif du transfert",
        mm_note: "Vos billets sont envoyés par email uniquement après que notre équipe a VU l'argent dans notre portefeuille — généralement en quelques heures.",
        mm_step1: "Étape 1 — Envoyez l'argent D'ABORD",
        mm_step2: "Étape 2 — Après l'envoi, confirmez votre paiement ci-dessous",
        pending_title: "Paiement pas encore confirmé",
        pending_sub: "MonCash n'a pas confirmé ce paiement. Aucun débit n'a été effectué et aucun billet n'a été émis. Si vous avez déjà payé, contactez-nous avec votre référence ci-dessous et nous réglerons cela immédiatement.",
        mm_sender: "Le numéro avec lequel vous avez payé",
        mm_txid: "ID de transaction (du SMS de confirmation — facultatif)",
        mm_paid: "J'ai payé",
        mm_done_title: "Paiement envoyé pour vérification",
        mm_done_text: "Mèsi ! Notre équipe vérifie votre transfert {method}. Vos billets QR arriveront par email à {email} dès confirmation.",
        mm_done_text_shop: "Merci ! Notre équipe vérifie votre paiement {method}. La confirmation de votre commande arrivera par email à {email} dès validation.",
        mm_new_order: "Nouvelle commande",
        secure_card_note: "Paiement Stripe sécurisé · Billet QR émis immédiatement après paiement",
        shop_checkout: "Paiement", shop_pay: "Payer en toute sécurité", shop_clear: "Vider", shop_add: "Ajouter", shop_soon: "Bientôt",
        cart_title: "Votre panier", cart_empty: "Votre panier est vide. La boutique vous attend.", cart_subtotal: "Sous-total",
        event_date: "Date", event_location: "Lieu", tickets_live: "Billets bientôt disponibles",
        faq_eyebrow: "Bon à savoir", faq_title: "Questions et réponses",
        contact_title: "Contact & Partenariats", contact_send: "Envoyer",
        journal_title: "Le Journal LAKOU", gallery_title: "Les souvenirs. La musique. L'expérience.",
        read: "Lire", journal_empty: "Les articles se préparent. Revenez bientôt.",
        about_eyebrow: "Notre histoire",
        about_title: "Plus qu'un événement. Un mouvement.",
        about_p1: "En Haïti, le lakou est la cour commune — l'espace partagé où les familles se rassemblent, où les tambours résonnent et où la vie se vit ensemble. Nous avons pris ce mot et bâti un mouvement dessus.",
        about_p2: "LAKOU mêle Afro House, Amapiano, Afrobeats et musique haïtienne dans des expériences premium en plein air — son cinématographique, lumière chaleureuse, belles personnes et une énergie qui ne se fabrique pas.",
        about_p3: "Le 12 décembre 2026, la sensation prend vie à Léogâne. Ensuite, l'île. Ensuite, le monde.",
        v1t: "Le tambour d'abord", v1d: "Afro House, Amapiano, Rabòday — le rythme est notre langue maternelle.",
        v2t: "La communauté avant la foule", v2d: "Lakou signifie la cour commune — le cœur de la vie communautaire haïtienne. Tout le monde y a sa place.",
        v3t: "D'Haïti vers le monde", v3d: "Construit à la maison, conçu pour la scène mondiale. Une île, de nombreuses villes.",
        v4t: "Une sensation, pas un événement", v4d: "Nous ne vendons pas des soirées. Nous créons des moments que les gens gardent en eux.",
        grow_title: "Grandissez avec le mouvement",
        grow_sub: "Annonces de la programmation, billets et nouvelles villes — en avant-première.",
        login_sub: "Connectez-vous à votre compte", login_google: "Continuer avec Google", login_or: "ou connexion équipe",
        login_btn: "Se connecter", login_note: "Les comptes staff et admin sont fournis par l'équipe LAKOU.",
        pay_confirming: "Confirmation du paiement…",
        pay_in_ticket: "C'est confirmé. Rendez-vous à Léogâne.", pay_in_shop: "Commande confirmée.",
        pay_ticket_sub: "Vos billets QR sont ci-dessous, liés à votre email. Présentez-les à l'entrée.",
        pay_shop_sub: "Merci de porter le feeling. Votre commande merch est confirmée.",
        pay_back: "Retour à l'accueil", pay_fail: "Impossible de confirmer ce paiement",
        pay_fail_sub: "Si vous avez payé, vos billets apparaîtront sous peu — ou contactez-nous et nous réglerons cela.",
        cancel_title: "Paiement annulé",
        cancel_sub: "Aucun débit effectué. Votre place vous attend dès que vous êtes prêt.",
        cancel_tickets: "Retour aux billets",
        ci_title: "Validation des billets", ci_scan: "Scanner avec la caméra", ci_stop: "Arrêter la caméra",
        ci_or: "ou tapez le code", ci_validate: "Valider l'entrée",
        contact_general: "Général", contact_partner: "Devenir partenaire",
        form_message: "Comment pouvons-nous aider ?",
        mm_attach: "Joignez la capture du transfert (confirmation plus rapide)",
        mm_attached: "Capture jointe",
    }
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem("lakou_lang") || "en");
    const change = (l) => {
        setLang(l);
        localStorage.setItem("lakou_lang", l);
    };
    const t = (key, vars) => {
        let s = STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
        if (vars) for (const k in vars) s = s.replaceAll(`{${k}}`, vars[k]);
        return s;
    };
    return <LangContext.Provider value={{ lang, setLang: change, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
